import { jsx as u } from "@emotion/react/jsx-runtime";
import { useMemo as C, createContext as c, useContext as h } from "react";
import x from "deepmerge";
import { buildOptionsForGraphic as p } from "./helpers.js";
const n = c(void 0), l = () => {
  const t = h(n);
  if (!t)
    throw new Error("useChartContext must be used within a ChartProvider");
  return t;
}, w = ({
  dataTrackId: t,
  type: o,
  options: r = {},
  data: e,
  children: i
}) => {
  const s = x(p(o), r), m = C(() => ({
    dataTrackId: t,
    type: o,
    options: s,
    data: e
  }), [t, o, r, e]);
  return /* @__PURE__ */ u(n.Provider, { value: m, children: i });
};
export {
  w as ChartProvider,
  l as useChartContext
};
